(function() {

    angular
        .module('ngmvac')
        .factory('hours', Hours);

    function Hours() {

        return {
            list: [
				{
					data_view: '12:00 am',
					data_value: '00:00',
				},
				{
					data_view: '12:30 am',
					data_value: '00:30',
				},
				{
					data_view: '01:00 am',
					data_value: '01:00',
				},
				{
					data_view: '01:30 am',
					data_value: '01:30',
				},
				{
					data_view: '02:00 am',
					data_value: '02:00',
				},
				{
					data_view: '02:30 am',
					data_value: '02:30',
				},
				{
					data_view: '03:00 am',
					data_value: '03:00',
				},
				{
					data_view: '03:30 am',
					data_value: '03:30',
				},
				{
					data_view: '04:00 am',
					data_value: '04:00',
				},
				{
					data_view: '04:30 am',
					data_value: '04:30',
				},
				{
					data_view: '05:00 am',
					data_value: '05:00',
				},
				{
					data_view: '05:30 am',
					data_value: '05:30',
				},
				{
					data_view: '06:00 am',
					data_value: '06:00',
				},
				{
					data_view: '06:30 am',
					data_value: '06:30',
				},
				{
					data_view: '07:00 am',
					data_value: '07:00',
				},
				{
					data_view: '07:30 am',
					data_value: '07:30',
				},
				{
					data_view: '08:00 am',
					data_value: '08:00',
				},
				{
					data_view: '08:30 am',
					data_value: '08:30',
				},
				{
					data_view: '09:00 am',
					data_value: '09:00',
				},
				{
					data_view: '09:30 am',
					data_value: '09:30',
				},
				{
					data_view: '10:00 am',
					data_value: '10:00',
				},
				{
					data_view: '10:30 am',
					data_value: '10:30',
				},
				{
					data_view: '11:00 am',
					data_value: '11:00',
				},
				{
					data_view: '11:30 am',
					data_value: '11:30',
				},
				{
					data_view: '12:00 pm',
					data_value: '12:00',
				},
				{
					data_view: '12:30 pm',
					data_value: '12:30',
				},
				{
					data_view: '01:00 pm',
					data_value: '13:00',
				},
				{
					data_view: '01:30 pm',
					data_value: '13:30',
				},
				{
					data_view: '02:00 pm',
					data_value: '14:00',
				},
				{
					data_view: '02:30 pm',
					data_value: '14:30',
				},
				{
					data_view: '03:00 pm',
					data_value: '15:00',
				},
				{
					data_view: '03:30 pm',
					data_value: '15:30',
				},
				{
					data_view: '04:00 pm',
					data_value: '16:00',
				},
				{
					data_view: '04:30 pm',
					data_value: '16:30',
				},
				{
					data_view: '05:00 pm',
					data_value: '17:00',
				},
				{
					data_view: '05:30 pm',
					data_value: '17:30',
				},
				{
					data_view: '06:00 pm',
					data_value: '18:00',
				},
				{
					data_view: '06:30 pm',
					data_value: '18:30',
				},
				{
					data_view: '07:00 pm',
					data_value: '19:00',
				},
				{
					data_view: '07:30 pm',
					data_value: '19:30',
				},
				{
					data_view: '08:00 pm',
					data_value: '20:00',
				},
				{
					data_view: '08:30 pm',
					data_value: '20:30',
				},
				{
					data_view: '09:00 pm',
					data_value: '21:00',
				},
				{
					data_view: '09:30 pm',
					data_value: '21:30',
				},
				{
					data_view: '10:00 pm',
					data_value: '22:00',
				},
				{
					data_view: '10:30 pm',
					data_value: '22:30',
				},
				{
					data_view: '11:00 pm',
					data_value: '23:00',
				},
				{
					data_view: '11:30 pm',
					data_value: '23:30',
				},
			],
			listCrop: [
				{
					data_view: '12:00 am',
					data_value: '00:00',
				},
				{
					data_view: '12:30 am',
					data_value: '00:30',
				},
				{
					data_view: '01:00 am',
					data_value: '01:00',
				},
				{
					data_view: '01:30 am',
					data_value: '01:30',
				},
				{
					data_view: '02:00 am',
					data_value: '02:00',
				},
				{
					data_view: '02:30 am',
					data_value: '02:30',
				},
				{
					data_view: '03:00 am',
					data_value: '03:00',
				},
				{
					data_view: '03:30 am',
					data_value: '03:30',
				},
				{
					data_view: '04:00 am',
					data_value: '04:00',
				},
				{
					data_view: '04:30 am',
					data_value: '04:30',
				},
				{
					data_view: '05:00 am',
					data_value: '05:00',
				},
				{
					data_view: '05:30 am',
					data_value: '05:30',
				},
				{
					data_view: '06:00 am',
					data_value: '06:00',
				},
				{
					data_view: '06:30 am',
					data_value: '06:30',
				},
				{
					data_view: '07:00 am',
					data_value: '07:00',
				},
				{
					data_view: '07:30 am',
					data_value: '07:30',
				},
				{
					data_view: '08:00 am',
					data_value: '08:00',
				},
				{
					data_view: '08:30 am',
					data_value: '08:30',
				},
				{
					data_view: '09:00 am',
					data_value: '09:00',
				},
				{
					data_view: '09:30 am',
					data_value: '09:30',
				},
				{
					data_view: '10:00 am',
					data_value: '10:00',
				},
			],
        }
    }

})();
